import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import { UsageType } from 'models/automation/Common';
import useManageLanguagesModal from './useManageLanguagesModal';

const ManageLanguagesButton = ({
  usageType,
  hideAutoTranslation,
}: {
  usageType: UsageType;
  hideAutoTranslation?: boolean;
}) => {
  const { openManageLanguagesModal } = useManageLanguagesModal({
    usageType,
    hideAutoTranslation,
  });
  const { t } = useTranslation();

  return (
    <Button
      onClick={openManageLanguagesModal}
      $colorScheme="green"
      data-testid={`manage-languages-button-automation-${usageType}`}
    >
      {t('pageAutomations.common.manageLanguages')}
    </Button>
  );
};

ManageLanguagesButton.defaultProps = {
  hideAutoTranslation: false,
};

export default ManageLanguagesButton;
